import React from 'react';
import { BlurSvgIcon, CloudySvgIcon, LittleCloudySvgIcon, RainSvgIcon, ShowerSvgIcon, SleetSvgIcon, SnowSvgIcon, SunnySvgIcon } from '../components/Icons';

type WeatherIconOptions = {
  size?: number;
  colorType?: 'default' | 'dark';
  showNoWeatherIcon?: boolean;
};

/**
 * 날씨 상태에 따른 SVG 아이콘을 반환하는 유틸리티 함수
 *
 * @description
 * - 날씨 상태 문자열을 받아서 해당하는 SVG 아이콘 컴포넌트를 반환합니다
 * - 아이콘 크기와 색상 타입을 커스터마이징할 수 있습니다
 * - 모든 날씨 상태(sunny, little_cloud, cloudy, blur, rain, sleet, snow, shower)를 지원합니다
 *
 * @param weather - 날씨 상태 문자열 ('sunny', 'little_cloud', 'cloudy', 'blur', 'rain', 'sleet', 'snow', 'shower')
 * @param size - 아이콘 크기 (픽셀 단위, 기본값: 48)
 * @param options - 추가 옵션 객체
 * @param options.colorType - 아이콘 색상 타입 ('default' | 'dark', 기본값: 'default')
 * @param options.showNoWeatherIcon - 날씨값 없을 때 noweather 아이콘 표시여부 (기본값: false)
 * @returns 해당 날씨에 맞는 SVG 아이콘 컴포넌트 또는 null (잘못된 날씨 상태인 경우)
 */
export const getWeatherIcon = (weather: string, size: number = 48, options: WeatherIconOptions = {}): React.ReactElement | null => {
  const { colorType = 'default', showNoWeatherIcon = false } = options;

  switch (weather) {
    case 'sunny':
      return <SunnySvgIcon size={size} colorType={colorType} />;
    case 'little_cloud':
      return <LittleCloudySvgIcon size={size} colorType={colorType} />;
    case 'cloudy':
      return <LittleCloudySvgIcon size={size} colorType={colorType} />;
    case 'blur':
      return <BlurSvgIcon size={size} colorType={colorType} />;
    case 'rain':
      return <RainSvgIcon size={size} colorType={colorType} />;
    case 'sleet':
      return <SleetSvgIcon size={size} colorType={colorType} />;
    case 'snow':
      return <SnowSvgIcon size={size} colorType={colorType} />;
    case 'shower':
      return <ShowerSvgIcon size={size} colorType={colorType} />;
    default:
      return <p className='no-weather-icon'>{showNoWeatherIcon ? <span className='material-symbols-rounded'>cloud_off</span> : '-'}</p>;
  }
};
